export const enum PredefinedStaticFilters {
  LOCATION_TYPE = 'locationType',
  UNIT_TYPE = 'unitType',
  PRICE_RANGE = 'priceRange',
  PROPERTY_TYPE = 'propertyType',
  SORT = 'sort',
}
const sortedFilters: PredefinedStaticFilters[] = [
  PredefinedStaticFilters.LOCATION_TYPE,
  PredefinedStaticFilters.UNIT_TYPE,
  PredefinedStaticFilters.PRICE_RANGE,
  PredefinedStaticFilters.PROPERTY_TYPE,
  PredefinedStaticFilters.SORT,
];

export const isFilterVisible = (filterName: string): boolean => {
  const GAB_BETWEEN_FILTERS = 8;
  const FILTER_WIDTH = 160 + GAB_BETWEEN_FILTERS;
  const OUT_SIDE_PADDING = 96;
  const SEARCH_BAR_WIDTH = 320;
  const RIGHT_SECTION_WIDTH = 332;

  const filterIndex = sortedFilters.findIndex((name) => filterName === name);
  const possibleWidth = FILTER_WIDTH * (filterIndex + 1) + GAB_BETWEEN_FILTERS;
  const availableWidth = window.screen.width - SEARCH_BAR_WIDTH - RIGHT_SECTION_WIDTH - OUT_SIDE_PADDING;
  return window.screen.width <= 768 ? true : possibleWidth > availableWidth;
};
